/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import { FunctionComponent } from 'react';

import { CursorManager } from '../../../../../core/navigation';
import { RootState, useTivoSelector } from '../../../../../core/tivo/tivo-redux-wrapper';
import { Mousetrap } from '../../../../common';
import { PinEntryCellInteractiveLayer } from './PinEntryCellInteractiveLayer';
import { IPinEntryCellProps } from './PinEntryCellProps';

import './PinEntryCell.scss';

const PinEntryCell: FunctionComponent<IPinEntryCellProps> = ({
    focused,
    value,
    visited,
    index,
}): JSX.Element => {
    const { isOverlayGhostHighlightActive } = useTivoSelector(
        (state: RootState) => state.overlayHighlight,
    );
    const { isCaretVisible } = useTivoSelector((state: RootState) => state.overlayDialog);
    const isCursorAppeared = CursorManager.isCursorAppeared();
    const pinDisplay = (
        <Mousetrap value={index} className="pin-cell">
            <div
                className={`icon-pin-control-arrow icon-arrow-up ${!focused ? 'hidden' : ''}`}
            ></div>
            <div className="pin-value">{visited && (focused ? value : '•')}</div>
            <div
                className={`icon-pin-control-arrow icon-arrow-down ${!focused ? 'hidden' : ''}`}
            ></div>
        </Mousetrap>
    );

    return (
        <div
            className={`pin-cell-container ${focused ? 'highlighted' : ''} ${isOverlayGhostHighlightActive && focused ? 'ghost' : ''} `}
        >
            {focused ? (
                <PinEntryCellInteractiveLayer focused={isCaretVisible && isCursorAppeared} />
            ) : null}
            {pinDisplay}
        </div>
    );
};

export default PinEntryCell;
